
export default {
  name: "FormButton",
  props: {
    fsi: {
      type: String,
      default: '17'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: 'white',
    },
    width: {
      type: String,
      required: false,
    },
    height: {
      type: String,
      required: false,
      default: '50'
    },
    redhover: {
      type: Boolean,
      required: false,
      default: false
    },
    dis: {
      type: Boolean,
      required: false,
      default: false
    }    
  },
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
